<template>
    <!-- 类似于登录，在输入框下面做提示信息的 -->
    <div class="input-bottom-tip flex-jf-btw" v-if="tipInfo!=''">
        <p class="flex-1"></p>
        <p class="input-bottom-tip-info flex" :style="styleOver">
            <slot>
                <!-- <img src="../../assets/img/cwts.png"> -->
                <span>{{tipInfo}}</span>
            </slot>
        </p>
    </div>
</template>
<script>
    export default {
        props:['styleCpt','tipInfo'],
        data(){
            return{
                styleOver:'width:17.3rem;'
            }
        } 
    }
</script>
<!-- 因特殊，此处没有加 scoped -->
<style lang="less" >
    .input-bottom-tip{
        margin:.3rem 0 .8rem;
        p.input-bottom-tip-info{
            line-height: .8rem;
            img{
                width:.8rem;
                height:.8rem;
                margin:0 .3rem 0 0;
            }
            span{
                color:#D30B01;
            }
        }
    }
    .input-bottom-tip + .input-bottom-tip{
        margin: -.6rem 0 .5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/inputBottomTip.vue